/**
 * Compare semver-like app versions (major.minor.patch).
 * Returns negative if current < required, 0 if equal, positive if current > required.
 */
export function compareAppVersions(current: string, required: string): number {
  const parse = (raw: string) => String(raw ?? '')
    .trim()
    .split('.')
    .map((part) => Number.parseInt(part.replace(/[^0-9].*$/, ''), 10))
    .map((n) => (Number.isFinite(n) ? n : 0));

  const a = parse(current);
  const b = parse(required);
  const len = Math.max(a.length, b.length, 3);

  for (let i = 0; i < len; i += 1) {
    const av = a[i] ?? 0;
    const bv = b[i] ?? 0;
    if (av !== bv) return av - bv;
  }
  return 0;
}

export function isAppVersionSupported(current: string, minimum: string): boolean {
  if (!minimum.trim()) return true;
  return compareAppVersions(current, minimum) >= 0;
}
